<template>
  <div class="subs messages-group">
    <subscription-message-header-row @changenotification="changeNotification" :notificationProp="notifyAll" :email="emailSettings"/>
  </div>
</template>

<script>
import SubscriptionMessageHeaderRow from './SubscriptionMessageHeaderRow.vue';
import SubscriptionMessageRow from './SubscriptionMessageRow.vue';
import api from '../../../api/api';

export default {
  components: {SubscriptionMessageHeaderRow, SubscriptionMessageRow},
  props: ["messages"],
  data() {
    return {
      profileMessages: [],
      notifyAll: false,
      emailSettings: null,
    }
  },
  created() {
    this.notifyAll = this.messages;
    api.get('/Communication/messages').then(r => {
      this.emailSettings = r.data;
    });
  },
  watch: {
    messages(newValue) {
      this.notifyAll = newValue;
    },
  },
  methods: {
    changeNotification(e) {
      api.post('/Subscription/messages/bulk', {
        subscribeAll: e
      });
    },
  },
}
</script>

<style>

</style>
